<span class="value">{{ formControl.value}}</span>

<button type="button" class="btn" (click)="manuallyTransitionToState()">
    <clr-icon shape="step-forward-2" class="is-warning"></clr-icon>
    {{ 'order.manually-transition-to-state' | translate }}
</button>

